import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',

      backgroundColor: theme.palette.common.white,
      border: theme.shape.borderLightGray,
      boxShadow: '0px 7px 10px rgba(55, 73, 107, 0.0818127)',
      borderRadius: theme.shape.borderRadius,

      padding: '15px 90px 15px 15px',
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      marginRight: theme.spacing(2),
    },
    text: {
      flex: 1,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(17),
      color: theme.palette.text.secondary,
      whiteSpace: 'pre-wrap',
      '& a': {
        color: COLORS.primary.default,
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
    informationIcon: {
      fontSize: theme.typography.pxToRem(16),
      marginLeft: theme.spacing(2),
    },
  }),
  { name: 'ErrorPanel' }
);
